import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { Toast } from "../../components";
import "./styles.scss";
import Layout from "../../layout";
import Backicon from "../../assets/images/mobback.svg";
import Homeicon from "../../assets/images/homeIcon.svg";
import DisableRight from "../../assets/images/DisableRight.svg";
import NavRight from "../../assets/images/navRight.svg";
import InfoIcon from "../../assets/images/infoIcon.svg";
import CheckboxOn from "../../assets/images/CheckboxOn.svg";
import CheckboxOff from "../../assets/images/CheckboxOff.svg";
import RequiredIcon from "../../assets/images/required.svg";
import Closeicon from "../../assets/images/SheetClose.svg";
import DatePicker from "react-date-picker";
import moment from "moment";
import axios from "../../redux/axios";
import Sheet from "react-modal-sheet";
import IndividualRecipient from "./IndividualRecipient";

const AddRecipient = (props) => {
  const { close } = props;
  const history = useHistory();
  const user = useSelector((state) => state.auth);
  const [country, setCountry] = useState();
  const [mobileView, setMobileView] = useState(false);
  const [btmSheet, setbtmSheet] = useState(false);

  const [addRelative, setAddRelative] = useState(false);
  const schema = yup.object().shape({
    firstName: yup.string().required("firstName is required"),
    lastName: yup.string().required("lastName is required"),
    gender: yup.string().required("gender is required"),
    email: yup
      .string()
      .email("Must be a valid email")
      .max(255)
      .required("Email is required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [added, setAdded] = useState(false);
  const [nphone, setNphone] = useState();
  const [error, setError] = useState(false);
  const [errName, setErrName] = useState("");
  const [relativeArray, setRelativeArray] = useState([
    { id: "1", name: "Mrs. Promise Akintunde" },
    { id: "2", name: "Joy Akintunde" },
    { id: "3", name: "Andrew Akintunde" },
    { id: "4", name: "Munachi Kaimachukwuemeka" },
    { id: "5", name: "Andrew Peter" },
  ]);
  const [selectedRelative, setSelectedRelative] = useState([]);
  const [myself, setMyself] = useState(false);
  const [date, setDate] = useState("");

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  const handleRadio = (id, val) => {
    const idToRemove = id;
    if (selectedRelative.includes(val)) {
      const filteredPeople = selectedRelative.filter(
        (item) => item.uuid !== idToRemove
      );
      setSelectedRelative(filteredPeople);
    } else {
      setSelectedRelative([...selectedRelative, val]);
    }
  };
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((res) => {
        setCountry(res.country_code.toLowerCase());
      })
      .catch((data, status) => {
        console.log("Request failed:", data);
      });
  }, []);
  const realativeFetch = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/patient/consumer/${user.uuid}`)
      .then((res) => {
        let response = res.data;
        response = response.filter((i) => i.relationship === undefined);
        setRelativeArray(response);
      })
      .catch((err) => {});
  };
  useEffect(async () => {
    realativeFetch();
  }, []);

  const handleSubmitForm = async (data, e) => {
    if (date === "") {
      setErrName("Dob is Required");
      setError(true);
      return false;
    }
    if (nphone.length < 5) {
      setErrName("Phone is Required");
      setError(true);
      return false;
    }
    const formData = {
      email: data.email,
      first_name: data.firstName,
      last_name: data.lastName,
      full_name: data.firstName + " " + data.lastName,
      gender: data.gender,
      mobile: nphone,
      dob: moment(date).format("YYYY-MM-DD"),
    };
    await axios
      .post(`${process.env.REACT_APP_API_URL}/patient/doctall/`, formData)
      .then((res) => {
        setAdded(true);
        e.target.reset();
        reset();
        setDate("");
        setNphone("");
        setAddRelative(false);
        setbtmSheet(false);
        realativeFetch();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleRecipient = () => {
    if (myself === false && selectedRelative.length === 0) {
      setErrName("Please Select the Recipient");
      setError(true);
      return false;
    }
    // history.push({
    //   pathname: '/shoppingCart',
    //   state: { 'realtive': selectedRelative, 'myself': myself }
    // })
    close();
    history.push({
      pathname: "/cart-update",
      state: { realtive: selectedRelative, myself: myself },
    });
  };

  React.useEffect(() => {
    window.scrollTo(0, 50);
  }, []);

  return (
    <>
      {/* <Layout> */}
      <div className="parentContainer">
        <div className="add-recipient-conatiner">
          {/* {!mobileView ? <div className="header-row-pc">
            <img src={Homeicon} alt="HomeImg" onClick={() => history.push('/')} />
            <img src={DisableRight} alt="Rightnav" />
            <div className="header-text" onClick={() => history.push('/populartest')}>Diagnostic Tests</div>
            <img src={DisableRight} alt="Rightnav" />
            <div className="header-text" onClick={() => history.goBack()}>Compare Price</div>
            <img src={NavRight} alt="navRight" />
            <div className="header-text" style={{ color: "#163E8C" }}>
              Add Test Recipients
            </div>
          </div>
            : <div className="header-back-row" onClick={() => history.goBack()}>
              <img src={Backicon} alt="Backicon" />
              <div className="back-text">Back</div>
            </div>} */}
          <div className="container-outer">
            <div className="header-text">Hi {user.full_name}</div>
            <div className="sub-header-text">
              Select who you’d like to purchase the test for.{" "}
            </div>
            <div className="info-container-out">
              <img src={InfoIcon} alt="InfoIcon" />
              <div className="info-text">
                Here you can add the persons you want to buy the test for. You
                can also add new persons here as well.{" "}
              </div>
            </div>
            <div className="myself-cont-out">
              <div className="myself-check">
                <input
                  type="checkbox"
                  name="mySelf"
                  onChange={(e) => {
                    e.stopPropagation();
                    setMyself(e.target.checked);
                  }}
                  value={myself}
                  checked={myself}
                />
              </div>
              <div className="title-text" style={{ marginLeft: "10px" }}>
                Myself
              </div>
            </div>
            <div className="relatives-head">My Relatives</div>
            <div className="relative-content">
              {relativeArray.map((val, index) => {
                return (
                  <IndividualRecipient
                    key={index}
                    index={index}
                    val={val}
                    handleRadio={handleRadio}
                    selectedRelative={selectedRelative}
                  />
                );
              })}
            </div>
            <div
              className="addRelative-text"
              onClick={() => {
                !mobileView
                  ? addRelative
                    ? setAddRelative(false)
                    : setAddRelative(true)
                  : setbtmSheet(true);
              }}
            >
              + Add New Relative
            </div>

            {addRelative ? (
              <form onSubmit={handleSubmit(handleSubmitForm)}>
                <div className="addRelative-container-out">
                  <div className="header-font">Add New Relative Details</div>
                  <div className="form-cls-cont">
                    <div className="left-cont">
                      <div className="label-row">
                        <div className="label">First Name</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <input
                          type="text"
                          className="input"
                          {...register("firstName")}
                          placeholder="Enter first name"
                        />
                        <p className="errorFont">{errors.firstName?.message}</p>
                      </div>
                    </div>
                    <div className="right-cont">
                      <div className="label-row">
                        <div className="label">Last Name</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <input
                          type="text"
                          className="input"
                          {...register("lastName")}
                          placeholder="Enter last name"
                        />
                        <p className="errorFont">{errors.lastName?.message}</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-cls-cont">
                    <div className="left-cont">
                      <div className="label-row">
                        <div className="label">Date - of - Birth</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="inputFieldTwo">
                        <DatePicker
                          onChange={setDate}
                          value={date}
                          maxDate={moment().subtract(1, "day").toDate()}
                        />
                        <p className="errorFont">
                          {date === "" ? <>Dob Required</> : null}
                        </p>
                      </div>
                    </div>
                    <div className="right-cont">
                      <div className="label-row">
                        <div className="label">Gender</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <input
                          type="text"
                          className="input"
                          {...register("gender")}
                          placeholder="Select gender"
                        />
                        <p className="errorFont">{errors.gender?.message}</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-cls-cont">
                    <div className="left-cont">
                      <div className="label-row">
                        <div className="label">Email Address</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <input
                          type="email"
                          className="input"
                          {...register("email")}
                          placeholder="Enter email address"
                        />
                        <p className="errorFont">{errors.email?.message}</p>
                      </div>
                    </div>
                    <div className="right-cont">
                      <div className="label-row">
                        <div className="label">Phone Number</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <PhoneInput
                          containerClass=""
                          country={country}
                          value={nphone}
                          onChange={setNphone}
                        />
                        <p className="errorFont">
                          {nphone === "" || nphone === undefined ? (
                            <>Phone is Required</>
                          ) : null}
                        </p>
                      </div>
                    </div>
                  </div>
                  <input
                    className="button-cls"
                    type="submit"
                    value="Add Relative"
                  />
                  {/* <div className="button-cls"><span>Add Relative</span></div> */}
                </div>{" "}
              </form>
            ) : null}
          </div>
          <div
            className="continue-button"
            onClick={() => {
              handleRecipient();
            }}
          >
            <span>Continue</span>
          </div>
        </div>
        {/* toast */}
        <Toast
          text={`Relative Added Successfully`}
          type="success"
          open={added}
          setClose={() => {
            setAdded(false);
          }}
        />
        <Toast
          text={errName}
          type="error"
          open={error}
          setClose={() => {
            setError(false);
          }}
        />
        <Sheet
          isOpen={btmSheet}
          snapPoints={[800, 400, 100, 0]}
          onClose={() => setbtmSheet(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <form onSubmit={handleSubmit(handleSubmitForm)}>
                <div className="mob-addRelative-container-out">
                  <div className="header">
                    <img src={Closeicon} onClick={() => setbtmSheet(false)} />
                    <div>Add new relative</div>
                  </div>
                  <div className="form-cls-cont">
                    <div className="left-cont">
                      <div className="label-row">
                        <div className="label">First Name</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <input
                          type="text"
                          className="input"
                          {...register("firstName")}
                          placeholder="Enter first name"
                        />
                        <p className="errorFont">{errors.firstName?.message}</p>
                      </div>
                    </div>
                    <div className="right-cont">
                      <div className="label-row">
                        <div className="label">Last Name</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <input
                          type="text"
                          className="input"
                          {...register("lastName")}
                          placeholder="Enter last name"
                        />
                        <p className="errorFont">{errors.lastName?.message}</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-cls-cont">
                    <div className="left-cont">
                      <div className="label-row">
                        <div className="label">Date - of - Birth</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="inputFieldTwo">
                        <DatePicker
                          onChange={setDate}
                          value={date}
                          maxDate={moment().subtract(1, "day").toDate()}
                        />
                        <p className="errorFont">
                          {date === "" ? <>Dob Required</> : null}
                        </p>
                      </div>
                    </div>
                    <div className="right-cont">
                      <div className="label-row">
                        <div className="label">Gender</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <input
                          type="text"
                          className="input"
                          {...register("gender")}
                          placeholder="Select gender"
                        />
                        <p className="errorFont">{errors.gender?.message}</p>
                      </div>
                    </div>
                  </div>
                  <div className="form-cls-cont">
                    <div className="left-cont">
                      <div className="label-row">
                        <div className="label">Email Address</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <input
                          type="email"
                          className="input"
                          {...register("email")}
                          placeholder="Enter email address"
                        />
                        <p className="errorFont">{errors.email?.message}</p>
                      </div>
                    </div>
                    <div className="right-cont">
                      <div className="label-row">
                        <div className="label">Phone Number</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div className="input_container">
                        <PhoneInput
                          containerClass=""
                          country={country}
                          value={nphone}
                          onChange={setNphone}
                        />
                        <p className="errorFont">
                          {nphone === "" || nphone === undefined ? (
                            <>Phone is Required</>
                          ) : null}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="btncontainer">
                    <input
                      className="button-cls"
                      type="submit"
                      value="Add Relative"
                    />
                  </div>
                  {/* <div className="button-cls"><span>Add Relative</span></div> */}
                </div>{" "}
              </form>
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>
        {/* toast */}
      </div>
      {/* </Layout> */}
    </>
  );
};

export default AddRecipient;
